import type { ReactNode } from 'react';

interface StatsSubScreenProps {
  /** Имя экрана — показывают крошки в шапке, здесь не дублируем. */
  title: string;
  description?: string;
  children: ReactNode;
}

/**
 * Обёртка подэкранов «Статистики». Своей шапки нет (02.11.2026): «← Статистика»,
 * заголовок и подпись повторяли крошки «Статистика › Выгрузки» в топбаре.
 * Вкладок здесь нет намеренно — подэкран не один из пяти равноправных срезов.
 */
export function StatsSubScreen({ children }: StatsSubScreenProps): JSX.Element {
  return <div className="flex flex-col gap-4">{children}</div>;
}
